import { render, staticRenderFns } from "./DirectLogin.vue?vue&type=template&id=0d66beb3&"
import script from "./DirectLogin.vue?vue&type=script&lang=js&"
export * from "./DirectLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSheet,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d66beb3')) {
      api.createRecord('0d66beb3', component.options)
    } else {
      api.reload('0d66beb3', component.options)
    }
    module.hot.accept("./DirectLogin.vue?vue&type=template&id=0d66beb3&", function () {
      api.rerender('0d66beb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/DirectLogin.vue"
export default component.exports